import { Component, Input, OnInit } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChequeCuentaModeloMLS, CuentaService, ObtenerChequeCuentaME, ObtenerChequeCuentaMS } from 'src/app/open-api';
import { UserModel } from '../../models/user.model';

@Component({
  selector: 'app-cuenta-cheque',
  templateUrl: './cuenta-cheque.component.html',
  styleUrls: ['./cuenta-cheque.component.scss']
})
export class CuentaChequeComponent implements OnInit {

  @Input() usuario?: UserModel;
  @Input() set SecuencialCuenta(secuencial: number) {
    this.secuencialCuenta = secuencial;
  };
  secuencialCuenta?: number;
  cheques?: ChequeCuentaModeloMLS[] = [];
  hoy = new Date();
  fechaInicio = new Date(this.hoy.setDate(this.hoy.getDate() - 7));
  fechaFin = new Date();
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;

  constructor(
    private cuentaService: CuentaService,
    private spinner: NgxSpinnerService,
    private localeService: BsLocaleService
  ) {
    this.localeService.use('es');
  }

  ngOnInit(): void {
  }

  ObtenerCheques() {
    this.spinner.show();
    const parametro: ObtenerChequeCuentaME = {
      secuencialCuenta: this.secuencialCuenta,
      secuencialEmpresa: this.usuario?.secuencialEmpresa,
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin
    };
    this.cuentaService.apiV10CuentaObtenerChequesPost(parametro).subscribe(cheques => {
      this.cheques = (cheques?.movimientosCuentaCheque || [])
        .map((cuenta, i) => ({ id: i + 1, ...cuenta }))
        .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
      this.cantidad = cheques?.movimientosCuentaCheque?.length || 0;
      this.spinner.hide();
    });
  }
}
